import { JamfAssetItem } from 'store/slices/integrations/jamf/assets/types';

export const useTransformToTableData = (assets: JamfAssetItem[]) => {
  if (!assets || !assets.length) return [];
  
  return assets.map((asset) => {
    return {
      id: asset.id,
      jamfAssetId: {
        text: asset.jamfId || '-',
      },
      allwhereAssetNumber: {
        text: asset.assetNumber || '-',
        link: asset.assetNumber ? `/assets/${asset.id}` : undefined,
        openInNewTab: true,
        bold: true,
        underlined: true,
      },
      serialNumber: {
        text: asset.serialNumber || '-',
      },
      make: {
        text: asset.make || '-',
      },
      model: {
        text: asset.model || '-',
      },
    };
  });
}; 
